import { render, staticRenderFns } from "./VoucherPurchase.vue?vue&type=template&id=134ac82c"
import script from "./VoucherPurchase.vue?vue&type=script&lang=js"
export * from "./VoucherPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports